export default "__VITE_ASSET__BwmZUi6G__"